import * as actionTypes from './actionTypes';

// 完全回到initstate
export const setGRestore = () => ({
    type: actionTypes.SET_GRESTORE,
});

// 重置選項，若有月曆回到預選第一天
export const setGReset = () => ({
    type: actionTypes.SET_GRESET,
});

export const setCalendar = (payload: any) => ({
    type: actionTypes.SET_GCALENDAR,
    payload,
});

export const setTicketNum = (payload: any) => ({
    type: actionTypes.SET_GTICKECTNUM,
    payload,
});

export const setSession = (payload: any) => ({
    type: actionTypes.SET_GSESSION,
    payload,
});

export const setSessionPicked = (payload: any) => ({
    type: actionTypes.SET_GSESSIONPICKED,
    payload,
});

export const setTotalAmount = (payload: any) => ({
    type: actionTypes.SET_GTOTALAMOUNT,
    payload,
});

export const setGDetail = (payload: any) => ({
    type: actionTypes.SET_GDETAIL,
    payload,
});

export const setGTempCalendarData = (payload: any) => ({
    type: actionTypes.SET_GTEMPCALENDARDATA,
    payload,
});

export const setGCalenderRef = (payload: any) => ({
    type: actionTypes.SET_GCALENDARREF,
    payload,
});

export const setIsGDSDetailLoading = (payload: any) => ({
    type: actionTypes.SET_ISGDSDETAILLOADING,
    payload,
});

export const setGDSDetailFetchFail = (payload: any) => ({
    type: actionTypes.SET_GDSDETAILFETCHFAIL,
    payload,
});

export const setIsGDSSessionLoading = (payload: any) => ({
    type: actionTypes.SET_ISGDSSESSIONLOADING,
    payload,
});

export const setGDSSessionFetchFail = (payload: any) => ({
    type: actionTypes.SET_GDSSESSIONFETCHFAIL,
    payload,
});

export const setGNowList = (payload: any) => ({
    type: actionTypes.SET_GNOWLIST,
    payload,
});

export const setGNowListData = (payload: any) => ({
    type: actionTypes.SET_GNOWLISTDATA,
    payload,
});

export const setGCalenderErr = (payload: string) => ({
    type: actionTypes.SET_GCALENDARERR,
    payload,
});

export const setGSessionErr = (payload: string) => ({
    type: actionTypes.SET_GSESSIONERR,
    payload,
});

export const setGTicketErr = (payload: string) => ({
    type: actionTypes.SET_GTICKETERR,
    payload,
});

export const setScrollTo = (payload: any) => ({
    type: actionTypes.SET_GSCROLLTO,
    payload,
});

export const setSubmitWatcher = (payload: any) => ({
    type: actionTypes.SET_GSUBMITWATCHER,
    payload,
});

export const setIsSubmitSuccess = (payload: any) => ({
    type: actionTypes.SET_ISGSUBMITSUCCESS,
    payload,
});
